export { default } from './SettingsEducation.jsx';
